export const ANNIHILATE_FIELD = 'ANNIHILATE_FIELD'
